import axios from 'axios';

import c from '../helpers/constants';

export function getCategories() {
  return (
    axios({
      url: c.API_ENDPOINTS.CATEGORIES,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
